import {registerTileSchema} from '#core/application/schema-registry.js';

import PARTICIPANTS from './participants.palette-schema.yaml';

registerTileSchema(PARTICIPANTS);

export function generateParticipants(TILE) {
    return {
        container: {
            style: {
                justifyContent: 'center',
                maxWidth: '100%',
            },
        },
        outrightText: {
            style: {
                ...TILE.PARTICIPANTS_OUTER_TEXT,
            },
        },
        separatorText: {
            style: {
                fontSize: 12, // can be hardcoded, there's no need to add possibility to change this value via Mozaic
                color: TILE.PARTICIPANTS_SEPARATOR_COLOR,
            },
        },
        participantItem: {
            textWrapper: {
                style: {
                    flexDirection: 'column',
                },
            },
            text: {
                style: {
                    ...TILE.PARTICIPANTS_TEXT,
                },
            },
            startingPitcherName: {
                style: {
                    ...TILE.PITCHER_TEXT,
                },
            },
        },
        drawLabelText: {
            style: {
                ...TILE.PARTICIPANTS_TEXT,
            },
        },
    };
}
